const trangThaiCapPhat = {
  daCapPhat: 1,
  chuaCapPhat: 2,
}
const trangThaiCapPhats = [
  { name: 'Chưa cấp phát', id: 2 },
  { name: 'Đã cấp phát', id: 1 },
]
const getTrangThaiCapPhat = (value = 0) => {
  switch (value) {
    case trangThaiCapPhat.daCapPhat:
      return 'Đã cấp phát'
    case trangThaiCapPhat.chuaCapPhat:
      return 'Chưa cấp phát'
    default:
      return ''
  }
}
export default trangThaiCapPhat
export { getTrangThaiCapPhat, trangThaiCapPhats }
